// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .ant-tabs-tab-btn {\n  color: rgb(243, 133, 60);\n} */\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: rgb(243, 133, 60);\n}\n\n.ant-tabs-tab:hover {\n  color: rgb(243, 133, 60);\n}\n\n.ant-tabs-tab-btn:hover {\n  color: rgb(243, 133, 60);\n}\n\n/* .sc-GamvQ {\n  position: relative;\n  left: -50px;\n  top: 10px;\n} */\n\n.ant-empty-footer > h3 {\n  font-size: 1.3rem;\n}\n", ""]);
// Exports
module.exports = exports;
